<template>
    <div>
        <loading :active.sync="bool_fullLoading"></loading>
        <iframe src="https://afbproduct.com/En9Bve9Xg77RULah/" width="100%" @load="HelpFrameLoad" ref="helpframe" frameborder="0"></iframe>
    </div>
</template>

<script>
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';

    export default {
        components: {
            Loading
        },
        data () {
            return {
                bool_fullLoading: false,
            }
        },
        computed: {
        },
        mounted() {
            this.GetWindowHeight();
            document.body.classList.add("fullframe");
        },
        methods: {
            GetWindowHeight(e) {
                this.$refs.helpframe.height = window.innerHeight;
            },
            HelpFrameLoad() {
                this.bool_fullLoading = false;
            }
        },
        created() {
            window.addEventListener("resize", this.GetWindowHeight);
            this.bool_fullLoading = true;
            
        },
        destroyed() {
            window.removeEventListener("resize", this.GetWindowHeight);
            document.body.classList.remove("fullframe");
        },
    }
</script>
<style>
    body.fullframe {
        overflow: hidden;
    }
</style>



// WEBPACK FOOTER //
// src/components/Page/VideoGuide.vue